if (!customElements.get('bf-navigation')) {
  customElements.define('bf-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller && !this.controller.signal.aborted) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const desktop = this.querySelector('.bf-nav-products');
      const dropdowns = [...this.querySelectorAll('.bf-nav-desktop > details')];
      const closeDropdowns = () => dropdowns.forEach(item => { item.open = false; });
      dropdowns.forEach(item => item.querySelector('summary').addEventListener('click', () => {
        dropdowns.forEach(other => { if (other !== item) other.open = false; });
      }, options));
      const opener = this.querySelector('.bf-nav-open');
      const dialog = this.dialog || this.querySelector('dialog');
      if (!desktop || !opener || !dialog) return;
      this.dialog = dialog;
      // Escape sticky-header transforms; native modal provides focus trapping.
      document.body.append(dialog);
      const close = () => { if (dialog.open) dialog.close(); };
      opener.addEventListener('click', () => {desktop.open = false;dialog.showModal();document.body.classList.add('bf-nav-locked');opener.setAttribute('aria-expanded','true');}, options);
      dialog.querySelector('.bf-nav-close').addEventListener('click', close, options);
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', close, options));
      dialog.addEventListener('click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) close();}}, options);
      dialog.addEventListener('close', () => {document.body.classList.remove('bf-nav-locked');opener.setAttribute('aria-expanded','false');opener.focus();}, options);
      document.addEventListener('click', e => {if (!this.contains(e.target)) closeDropdowns();}, options);
      document.addEventListener('keydown', e => {if(e.key==='Escape'){const opened=dropdowns.find(item=>item.open);if(opened){closeDropdowns();opened.querySelector('summary').focus();}}}, options);
      this.addEventListener('focusout', e => {
        // A click on blank panel space has no focus target. Closing a native
        // details synchronously during that blur can crash Chromium. Keep
        // pointer dismissal in the outside-click handler; defer keyboard exit.
        if (!e.relatedTarget || this.contains(e.relatedTarget)) return;
        queueMicrotask(() => {
          if (this.isConnected && !this.contains(document.activeElement)) closeDropdowns();
        });
      }, options);
      window.addEventListener('resize', () => {if(window.innerWidth>=1280) close();else closeDropdowns();}, options);
    }
    disconnectedCallback(){
      // Theme header moves can disconnect/reconnect within the same DOM update.
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.dialog?.remove();
        document.body.classList.remove('bf-nav-locked');
      });
    }
  });
}
